"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Read4SpeedCollections = void 0;
const CollectionNames_1 = require("./CollectionNames");
class Read4SpeedCollections {
    constructor(firestore) {
        this.firestore = firestore;
    }
    textsRef() {
        return this.firestore.collection(CollectionNames_1.COLLECTION_NAMES.TEXTS);
    }
    textQuotesRef() {
        return this.firestore.collection(CollectionNames_1.COLLECTION_NAMES.TEXT_QUOTES);
    }
    paragraphCommentsRef() {
        return this.firestore.collection(CollectionNames_1.COLLECTION_NAMES.PARAGRAPH_COMMENTS);
    }
    readingHistoryItemsRef() {
        return this.firestore.collection(CollectionNames_1.COLLECTION_NAMES.READING_HISTORY_ITEMS);
    }
    userProfilesRef() {
        return this.firestore.collection(CollectionNames_1.COLLECTION_NAMES.USER_PROFILES);
    }
    scheduledEmailsRef() {
        return this.firestore.collection(CollectionNames_1.COLLECTION_NAMES.SCHEDULED_EMAILS);
    }
    analyticsEventsRef() {
        return this.firestore.collection(CollectionNames_1.COLLECTION_NAMES.ANALYTICS_EVENTS);
    }
    booksRef() {
        return this.firestore.collection(CollectionNames_1.COLLECTION_NAMES.BOOKS);
    }
    bookPagesRef() {
        return this.firestore.collection(CollectionNames_1.COLLECTION_NAMES.BOOK_PAGES);
    }
}
exports.Read4SpeedCollections = Read4SpeedCollections;
//# sourceMappingURL=Read4SpeedCollections.js.map